module.exports = __webpack_public_path__ + "media/images/icons/geo-icon-112ac9b9b78ae8375320ca7e46d886cc.svg";